import { FormattedMessage } from 'react-intl';
import { formatCurrency } from '../../utils/helpers';

interface INegativeMonthlyRateBudgetStepProps {
  negativeMonthlyRateLoan: number;
}

const NegativeMonthlyRateBudgetStep = ({
  negativeMonthlyRateLoan,
}: INegativeMonthlyRateBudgetStepProps) => (
  <div className="shadow-box">
    <div>
      <p>
        <FormattedMessage id="budget_calculator.loan_impossible_description" />
      </p>
      <p>
        <FormattedMessage
          id="budget_calculator.missing_monthly_value"
          values={{ value: <b>{formatCurrency(Math.abs(negativeMonthlyRateLoan))}</b> }}
        />
      </p>
    </div>
  </div>
);

export default NegativeMonthlyRateBudgetStep;
